import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { useHistory } from 'react-router-dom'
import { wholeContainerStyle, mainColumnStyle } from '@/constants/layout'
import { Header } from '@/components/organisms/header'
import { SideMenu } from '@/components/organisms/side-menu'
import { LoadingFull } from '@/components/molecules/loading-full'
import * as api from '@/apis/aipass'
import { MonthlySummary } from '@/models/sales-manager/detail'
import { DetailHeader } from '@/components/organisms/sales-manager/closing-detail/header'
import { Sales } from '@/components/organisms/sales-manager/closing-detail/sales'
import { Payment } from '@/components/organisms/sales-manager/closing-detail/payment'

export const SalesManagerDetailByMonthly: React.FC = () => {
  const { t } = useTranslation()
  const { id: salesManagerMonthId } = require('query-string').parse(window.location.search)
  const mode = 'month'
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [salesTotalDetail, setSalesTotalDetail] = useState<MonthlySummary>()
  const history = useHistory()

  useEffect(() => {
    setIsLoading(true)
    api.fetchSalesManagerMonthlySummary({ salesManagerMonthId }).then(res => {
      if (!res) {
        alert('締め状況が登録されていません')
        history.goBack()
        return
      }
      setSalesTotalDetail(res)
      setIsLoading(false)
    })
  }, [])

  return (
    <div css={wholeContainerStyle}>
      <SideMenu />
      <div className="mainColumn" css={mainColumnStyle}>
        <Header isBack title={t('Sales management')} goBack={history.goBack} />
        {salesTotalDetail && (
          <div css={mainWrapperStyle}>
            <DetailHeader salesTotalDetail={salesTotalDetail} mode={mode} />
            <div css={cardFlexStyle}>
              <div>
                <Sales salesTotalDetail={salesTotalDetail} mode={mode} />
              </div>
              <div>
                <Payment salesTotalDetail={salesTotalDetail} />
              </div>
            </div>
          </div>
        )}

        <LoadingFull isLoading={isLoading} />
      </div>
    </div>
  )
}

const cardFlexStyle = css({
  display: 'flex',
  gap: 16,
  '> div': { width: '50%', gap: 16, display: 'flex', flexDirection: 'column' },
})

const mainWrapperStyle = css({
  width: '100%',
  padding: '24px 24px 0',
  marginBottom: 70,
  overflow: 'scroll',
  '::-webkit-scrollbar': {
    display: 'none',
  },
})
